export default {
  excluded: ["DCB01", "DCV01", "DCV02", "DCG01", "DCM01", "DCF01", "DCS01", "DCR01"],
  include: ["DCF01", "DCL01", "DCG01", "DCO01", "DCP01"],
  viltLight: "DCV01",
  viltDark: "DCV02"
};
